@if (DataService.TornStatus == 'ShowUpcoming' || DataService.TornStatus == 'ShowCompleted') {
  <button (click)="DataService.TornStatus = ''" class="back-button">← Back</button>
  <div style="display: inline-flex">
    <button class="filter-button" (click)="changeFilter($event)">2026</button>
    <button class="filter-button" (click)="changeFilter($event)">2025</button>
    <button class="filter-button" (click)="changeFilter($event)">2024</button>
    <button class="filter-button" (click)="changeFilter($event)">2023</button>
    <button class="filter-button" (click)="changeFilter($event)">2022</button>
    <button class="filter-button" (click)="changeFilter($event)">2021</button>
    <button class="filter-button" (click)="changeFilter($event)">2020</button>
    <button class="filter-button" (click)="changeFilter($event)">2019</button>
    <button class="filter-button" (click)="changeFilter($event)">2018</button>
    <button class="filter-button" (click)="changeFilter($event)">2017</button>

    <button class="filter-button" (click)="changeFilter($event)">Canterbury</button>
    <button class="filter-button" (click)="changeFilter($event)">Auckland</button>
    <button class="filter-button" (click)="changeFilter($event)">Gisborne</button>
    <button class="filter-button" (click)="changeFilter($event)">Taupo</button>
    <button class="filter-button" (click)="changeFilter($event)">Super 6s</button>
    <button class="filter-button" (click)="changeFilter($event)">Masters</button>
    <button class="filter-button" (click)="changeFilter($event)">Nationals</button>
    <button class="filter-button" (click)="changeFilter($event)">Whanganui</button>
    <button class="filter-button" (click)="changeFilter($event)">Waikato</button>
    <button class="filter-button" (click)="changeFilter($event)">Tauranga</button>
    <button class="filter-button" (click)="changeFilter($event)">League</button>
  </div>
}
@if (DataService.TornStatus == '') {
  <div class=torn-shell>
    <label class="torn-label">Tournaments</label>
    <div>
      <button type="button" class="BigButtons" (click)="DataService.TornStatus = 'ShowUpcoming';BackTo = 'ShowUpcoming'">Upcoming events</button>
      <button type="button" class="BigButtons" (click)="DataService.TornStatus = 'ShowCompleted';BackTo = 'ShowCompleted'">Completed events</button>
    </div>
  </div>
}

@if (DataService.TornStatus == 'ShowUpcoming' || DataService.TornStatus == 'ShowCompleted') {
  <div class="upcoming-tournaments">
    <div class="tournaments-grid">
      @for (torn of DataService.Torns; track torn; let i = $index) {
        @if (torn.dateOfEvent > Today && DataService.TornStatus == 'ShowUpcoming') {
            <div class="tournament-card">
              <div class="card-header" >
                <span class="event-date">{{ torn.name }}
                  @if (DataService.LoggedInUser.accessLevel >= 2) {
                    <button
                      mat-icon-button
                      class="edit-tab-btn"
                      (click)="DeleteTorn(torn)"
                      matTooltip="Delete Torn">
                      <mat-icon [class.red-icon]="isEditingPlayers">delete</mat-icon>
                    </button>
                  }
                </span>
              </div>
              <div class="card-body">
                <div class="tournament-info">
                  <p><strong>Event:</strong> {{ torn.dateOfEvent | date: 'dd MMM yyyy' }}</p>
                  <p><strong>Closes:</strong> {{ torn.closingDate | date: 'dd MMM yyyy' }}</p>
                  <p><strong>Entries:</strong> {{ torn.entryCount }}</p>
                </div>
                <div class="card-footer">
                  @if (torn.UserEntered) {
                    <img src="assets/images/star.png" title="You are in this tournament" class="user-star" />
                  }
                  <button type="button" class="view-button" (click)="changeTheTorn(torn)">View Details</button>
                </div>
              </div>
            </div>
          }
          @if (torn.dateOfEvent <= Today && DataService.TornStatus == 'ShowCompleted' && (TornFilter == '' || (TornFilter.indexOf('20') > -1 && torn.dateOfEvent.getFullYear() == TornFilter) || (torn.name.indexOf(TornFilter) > -1))) {
            <div class="tournament-card">
              <div class="card-header">
                <span class="event-date">{{ torn.name }}
                  @if (DataService.LoggedInUser.accessLevel == 3) {
                    <button
                      mat-icon-button
                      class="edit-tab-btn"
                      (click)="DeleteTorn(torn)"
                      matTooltip="Delete Torn">
                      <mat-icon [class.red-icon]="isEditingPlayers">delete</mat-icon>
                    </button>
                  }
                </span>
              </div>
              <div class="card-body">
                <div class="tournament-info">
                  <p><strong>Event Date:</strong> {{ torn.dateOfEvent | date: 'dd MMM yyyy' }}</p>
                  <p><strong>Entries:</strong> {{ torn.entryCount }}</p>
                </div>
                <div class="card-footer">
                  @if (torn.UserEntered) {
                    <img src="assets/images/star.png" title="You are in this tournament" class="user-star" />
                  }
                  <button type="button" class="view-button" (click)="changeTheTorn(torn)">View Details</button>
                </div>
              </div>
            </div>
        }
      }
      @if (DataService.LoggedInUser.accessLevel > 1) {
        <button type="button" class="add-tournament-btn" (click)="addTorn()" style="height: 50px;">
          <mat-icon>add_circle</mat-icon>
          <span>Create New Tournament</span>
        </button>
      }
    </div>
  </div>
}

@if (DataService.TornStatus == 'ShowTornDetails') {
  <div class="torn-details-container" style="height: 100%">
    <div class="tab-header-wrapper">
      <button mat-button color="primary" (click)="DataService.TornStatus = BackTo;DataService.SelectedTorn = null" class="back-button">← Back</button>
    </div>
    <mat-tab-group [(selectedIndex)]="SelectedTabIndex" (selectedTabChange)="TabChanged($event)">
      <mat-tab label="Players">
        <ng-template mat-tab-label>
          <span class="tab-label">
            Players
            @if (DataService.LoggedInUser.accessLevel > 1) {
              <button
                mat-icon-button
                class="edit-tab-btn"
                (click)="editPlayers($event)"
                matTooltip="Edit Players">
                <mat-icon [class.red-icon]="isEditingPlayers">edit</mat-icon>
              </button>
            }
          </span>
        </ng-template>
        <div class="players-container">
          <div class="players-header">
            <h2>Players ({{ DataService.SelectedTorn.entries.length }})</h2>
          </div>
          <div class="players-grid">
            @for (entry of DataService.SelectedTorn.entries; track entry; let i = $index) {
              <div class="player-card">
                <div class="player-card-header">
                  <div class="player-info">
                    <span class="player-name" [ngClass]="entry.gender === 'M' ? 'male' : 'female'"> {{ entry.name }}</span>
                    <span class="player-province" style="float: right">{{ entry.province }}</span>
                  </div>
                  @if (isEditingPlayers) {
                    <button type="button" class="delete-btn"
                      (click)="deleteSelectedEntry(entry)" title="Remove player">
                      ✕
                    </button>
                  }
                </div>
                <div class="player-events">
                  <table style="width: 100%">
                    <tbody>
                      @for (TheEvent of DataService.SelectedTorn.events; track TheEvent; let eventIndex = $index) {
                        <tr>
                          <td>
                            <label class="event-checkbox" >
                              <input type="checkbox" style="position: relative;top: 5px;"
                                [checked]="EventsEnteredArray[i]?.[eventIndex]"
                                [disabled]="!isEditingPlayers"
                                (change)="EditEventsInEntry(i, eventIndex, $event)" />
                              <span style="vertical-align: middle;">{{ TheEvent.name }} ({{ TheEvent.type }})</span>
                            </label>
                            @if (TheEvent.type === 'Doubles') {
                              <label (click)="removePartner(entry, TheEvent.id)" class="partner-name">{{getEventFor(entry, TheEvent.id)?.Partner?.name}}</label>
                            }
                            @for (TheEntryEvent of entry.eventsList; track TheEntryEvent; let EntryEventIndex = $index) {
                              <div>
                                @if (TheEntryEvent.id == TheEvent.id && TheEvent.type === 'Doubles' && isEditingPlayers && !TheEntryEvent.Partner) {
                                  <select
                                    class="partner-select"
                                    (ngModelChange)="partnerAssigned(entry, TheEvent.id, $event)"
                                    [ngModel]="TheEntryEvent.Partner">
                                    <option value="">Select Partner</option>
                                    @for (other of getEligiblePartners(TheEvent.id); track other) {
                                      @if (other.id !== entry.playerId && other.gender !== entry.gender) {
                                        <option
                                          [ngValue]="other">
                                          {{ other.name }}
                                        </option>
                                      }
                                    }
                                  </select>
                                }
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                @if (DataService.LoggedInUser.accessLevel == 3) {
                  <div class="player-footer">
                    @if (!isEditingPlayers) {
                      <span class="fee-status" [ngClass]="entry.feesPaid ? 'paid' : 'unpaid'">
                        {{ entry.feesPaid ? '✓ Paid' : 'Unpaid' }}
                      </span>
                    }
                    @if (isEditingPlayers == true) {
                      <button type="button" class="fee-toggle-btn"
                        (click)="entry.feesPaid = !entry.feesPaid; updateEntryFeeStatus(entry)"
                        [ngClass]="entry.feesPaid ? 'paid' : 'unpaid'">
                        {{ entry.feesPaid ? 'Mark Unpaid' : 'Mark Paid' }}
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </div>
          @if (isEditingPlayers && DataService.LoggedInUser.accessLevel > 0) {
            <div class="all-players-select">
              <label for="SelectAllPlayers">Select player from DB</label>
              <select id="SelectAllPlayers" [(ngModel)]="DataService.SelectedPlayer">
                @for (player of DataService.Players; track player) {
                  <option [ngValue]="player">
                    {{ player.name }} {{ player.province ? (' - ' + player.province) : '' }}
                  </option>
                }
              </select>
              <button
                type="button" class="add-player-btn" (click)="addANewEntry()">
                + Add Player
              </button>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="Draws">
        <ng-template mat-tab-label>
          <span class="tab-label" >
            Draws
            @if (DataService.LoggedInUser.accessLevel > 1) {
              <button
                mat-icon-button
                class="edit-tab-btn"
                (click)="editDraw(draw, $event)"
                matTooltip="Edit draw">
                <mat-icon [class.red-icon]="isEditingDraws">edit</mat-icon>
              </button>
            }
            @if (DataService.LoggedInUser.accessLevel > 1) {
              <button
                mat-icon-button
                class="edit-tab-btn"
                (click)="addNewDraw()"
                matTooltip="Create New Draw">
                <mat-icon>add</mat-icon>
              </button>
            }
          </span>
        </ng-template>
        @if (DataService.SelectedTorn.draws.length > 0) {
          <mat-tab-group [(selectedIndex)]="DataService.selectedDrawIndex" (selectedTabChange)="ChangeTheDraw($event)">
            @for (draw of DataService.SelectedTorn.draws; track draw; let i = $index) {
              <mat-tab label='{{draw.name}}'  (click)="ChangeTheDraw(draw)">
                <ng-template mat-tab-label >
                  <span class="tab-label" >
                    {{draw.name}}
                    <mat-icon [ngClass]="{'pink-icon': draw.gender === 'F', 'blue-icon': draw.gender === 'M'}">sports_tennis</mat-icon>
                    @if (draw.type == 'Doubles') {
                      <mat-icon [ngClass]="{'pink-icon': draw.gender === 'F', 'blue-icon': draw.gender === 'M'}">sports_tennis</mat-icon>
                    }
                    @if (DataService.LoggedInUser.accessLevel > 2 && isEditingDraws == true) {
                      <button
                        mat-icon-button
                        class="edit-tab-btn"
                        (click)="DeleteCurrentDraw(draw, $event)"
                        matTooltip="Delete draw">
                        <mat-icon [class.red-icon]="isEditingDraws">delete</mat-icon>
                      </button>
                    }
                  </span>
                </ng-template>
                <app-draws [isEditingDraws]="isEditingDraws" [ID]="draw.id"></app-draws>
              </mat-tab>
            }
          </mat-tab-group>
        }
      </mat-tab>
      <mat-tab label="Info">
        <ng-template mat-tab-label>
          <span class="tab-label"  >
            Info
            @if (DataService.LoggedInUser.accessLevel > 1) {
              <button
                mat-icon-button
                class="edit-tab-btn"
                (click)="editInfo($event)"
                matTooltip="Edit Info">
                <mat-icon [class.red-icon]="isEditingInfo">edit</mat-icon>
              </button>
            }
          </span>
        </ng-template>
        <div class="tournament-info-edit">
          <div class="left-info-section">
            <div class="info-section">
              <label>Tournament Name</label><input type="text" [(ngModel)]="DataService.SelectedTorn.name" />
            </div>
            <div class="info-section">
              <label>Event Date</label><input type="date" [(ngModel)]="DataService.SelectedTorn.eventDateString" />
            </div>
            <div class="info-section">
              <label>Finish Date</label><input type="date" [(ngModel)]="DataService.SelectedTorn.eventEndDateString" />
            </div>
            <div class="info-section">
              <label>Entries Close</label><input type="date" [(ngModel)]="DataService.SelectedTorn.entryClosedDateString" />
            </div>
            <div class="info-section">
              <label>Tournament Director</label>
              <select [(ngModel)]="DataService.SelectedTorn.directorId">
                @for (player of directors; track player) {
                  <option [ngValue]="player.id">
                    {{ player.name }}
                  </option>
                }
              </select>
            </div>
            <div class="info-section">
              <label>Venues</label><textarea [(ngModel)]="DataService.SelectedTorn.VenueInfo"></textarea>
            </div>
            <div class="info-section">
              <label>Accommodation</label><textarea [(ngModel)]="DataService.SelectedTorn.accomodationInfo"></textarea>
            </div>
            <div class="info-section">
              <label>Schedules</label><textarea [(ngModel)]="DataService.SelectedTorn.scheduleInfo"></textarea>
            </div>
          </div>
          <div class="right-info-section">
            <div class="info-section">
              <label>Prize Giving</label><textarea [(ngModel)]="DataService.SelectedTorn.prizeGivingInfo"></textarea>
            </div>
            <div class="info-section">
              <label>Extra Information</label><textarea [(ngModel)]="DataService.SelectedTorn.extraInfo"></textarea>
            </div>
            <div class="info-section">
              <label>Account Number</label><input type="text" [(ngModel)]="DataService.SelectedTorn.accountNumber" />
            </div>
            <div class="info-section">
              <label>Account Name</label><input type="text" [(ngModel)]="DataService.SelectedTorn.accountName" />
            </div>
            <div class="info-section">
              <label>Info Sheet</label>@if (DataService.LoggedInUser.accessLevel > 1) {
              <input type="file" (change)="onInfoSheetUpload($event)" accept=".txt"/>
            }
          </div>
          <div class="info-section">
            <label>Poster Image</label>@if (DataService.LoggedInUser.accessLevel > 1) {
            <input type="file" (change)="onPosterUpload($event)" accept="image/*"/>
          }
        </div>
        <div class="info-section">
          <label>Sponsor Image</label>@if (DataService.LoggedInUser.accessLevel > 1) {
          <input type="file" (change)="onSponsorUpload($event)" accept="image/*"/>
        }
      </div>
      <div class="info-section">
        <label>Live Stream URL</label><input type="url" [(ngModel)]="DataService.SelectedTorn.liveStreamURL" />
      </div>
    </div>
    @if (DataService.LoggedInUser.accessLevel > 1) {
      <button type="button" class="save-btn" (click)="UpdateTorn(DataService.SelectedTorn)">
        Save Tournament Info
      </button>
    }
    <button type="button" class="save-btn" (click)="Announce()">
        Email all players
    </button>
  </div>
</mat-tab>
<mat-tab label="Events">
  <ng-template mat-tab-label>
    <span class="tab-label"  >
      Events
      @if (DataService.LoggedInUser.accessLevel > 1) {
        <button
          mat-icon-button
          class="edit-tab-btn"
          (click)="editEvents($event)"
          matTooltip="Edit Events">
          <mat-icon [class.red-icon]="isEditingEvents">edit</mat-icon>
        </button>
      }
      @if (DataService.LoggedInUser.accessLevel > 1) {
        <button
          mat-icon-button
          class="edit-tab-btn"
          (click)="addEvent()"
          matTooltip="Create New Event">
          <mat-icon>add</mat-icon>
        </button>
      }
    </span>
  </ng-template>
  <div class="events-container">
    <div class="event-list">
      @for (event of DataService.SelectedTorn.events; track event; let eventIndex = $index) {
        <div class="event-section">
          <div class="event-title">
            @if (!isEditingEvents) {
              <h3>{{ event.name }} ({{ event.type }}) - {{event.type == 'Singles' ? "Players:" : "Pairs:"}} {{ event.Players.length }}</h3>
            }
            @if (isEditingEvents) {
              <input [(ngModel)]="event.name" />
            }
            @if (isEditingEvents) {
              <button type="button"
                class="delete-btn" (click)="deleteEvent(event, eventIndex)" title="Delete event">
                ✕
              </button>
            }
          </div>
          <div class="players-in-event">
            @for (player of event.Players; track player) {
              <div class="player-ranking">
                <div class="player-rank-info">
                  <span class="rank-name" [ngClass]="player.gender === 'M' ? 'male' : 'female'">
                    {{ player.name }}
                  </span>
                  @if (event.type === 'Doubles') {
                    <span class="rank-name" [ngClass]="FunctionService.getEventForPlayer(player.id, event.id)?.Partner?.gender === 'M' ? 'male' : 'female'">
                      /  {{  FunctionService.getEventForPlayer(player.id, event.id)?.Partner?.name }}
                    </span>
                  }
                  @if (event.type !== 'Doubles') {
                    <span class="rank-points">{{ player.singlesPoints }}</span>
                  }
                  @if (event.type === 'Doubles') {
                    <span class="rank-points"> {{ player.DoublesTotalPoints }}</span>
                  }
                </div>
              </div>
            }
            @if (event && event.Players && event.Players.length === 0) {
              <div class="no-players">
                <p>No players in this event</p>
              </div>
            }
          </div>
          @if (isEditingEvents) {
            <div class="Events-Edit">
              <label>Cost</label>
              <input type="number" [(ngModel)]="event.cost" /><br>
              <label>Minimum Age</label>
              <input type="number" [(ngModel)]="event.minAge" /><br>
              <label>Maximum Age</label>
              <input type="number" [(ngModel)]="event.maxAge" /><br>
              <label>Type</label>
              <select [(ngModel)]="event.type">
                <option value="Singles">Singles</option>
                <option value="Doubles">Doubles</option>
              </select><br>
              <label>Teams</label>
              <input type="checkbox" [(ngModel)]="event.Teams" /><br>
              <button type="button" class="save-btn" (click)="saveEvent(event, eventIndex)">Save Event</button>
              @if (showSavedLabel[eventIndex]) {
                <label class="saved-label" @fade>Event Saved</label>
              }
            </div>
          }
        </div>
      }
    </div>
    <!-- <button *ngIf="isEditingEvents && DataService.LoggedInUser.accessLevel === 3" type="button"
    class="add-event-btn" (click)="addEvent()">
    + Add Event
  </button> -->
</div>
</mat-tab>
@if (DataService.SelectedTorn.isTeams == true) {
  <mat-tab label="Teams">
    @if (DataService.SelectedTorn.Teams.length > 0) {
      <div style="display: inline-block;">
        <label for="chkEditTeams">Edit</label>
        <input type="checkbox" id="chkEditTeams" [(ngModel)]="DataService.SelectedTorn.EditTeams" style="height: 20px; margin-top: 0px"/>
      </div>
    }
    @if (DataService.SelectedTorn.EditTeams == true && DataService.SelectedTorn.Teams.length > 0) {
      <div>
        <EventHeadings style="display: inline-block; width: 592px;"><label style=" text-align: right; width: 196px;">Name</label><label style="text-align: right; width: 196px;">Event</label></EventHeadings><br />
        @for (team of DataService.SelectedTorn.Teams; track team) {
          <div>
            <div style="display: inline-block">
              <input id="teamName{{$index}}" [(ngModel)]="team.Name" ng-style="{backgroundColor: team.Colour}"/>
              <select id="EventList{{$index}}" name="EventList" [(ngModel)]="team._Event">
                @for (event of DataService.SelectedTorn.events; track event) {
                  <option value="{{event.Id}}">{{event.Name}}</option>
                }
              </select>
              <input type="color" id="clrPicker{{index}}" [(ngModel)]="team.Colour"/>
              @if (team.id > 0) {
                <button type="button" id="btnDeleteTeam{{$index}}" name="deleteTeam" (click)="deleteTeam(team, $index)">Delete</button>
              }
              @if (!team.id) {
                <button type="button" id="btnSaveTeam{{$index}}" name="saveTeam" (click)="saveNewTeam(team, $index)">Save</button>
                }<br />
              </div>
            </div>
          }
          @if (DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == LoggedInUser.id) {
            <button type="button" id="btnAddTeam" (click)="addTeam()">+</button>
          }
          @if (DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == LoggedInUser.id) {
            <button type="button" id="btnSaveTeams" (click)="saveTeams()">Save</button>
          }
        </div>
      }
      @if (DataService.SelectedTorn.EditTeams == false && DataService.SelectedTorn.Teams.length > 0) {
        <div>
          <table>
            <thead>
              <tr>
                <th>Position</th>
                <th>Team Name</th>
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              @for (team of DataService.SelectedTorn.Teams; track team) {
                <tr ng-style="{backgroundColor: team.Colour}">
                  <td>{{$index+1}}</td>
                  <td>{{team.Name}}</td>
                  <td>{{team.Points}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </mat-tab>
  }
  <!-- <mat-tab label="Schedules" *ngIf="DataService.SelectedTorn.draws.length > 0"></mat-tab> -->
  <!-- <mat-tab label="Settings"></mat-tab> -->
</mat-tab-group>
</div>
}

<!-- <div *ngIf="DataService.TornStatus == 'ChangeTorn'">
<div style="display: inline-block; left: 20%; position: absolute;">
  <input type="checkbox" id="EntryOpenToggle" name="EntryOpenToggle" [(ngModel)]="DataService.EntryOpenFilter" /><label for="EntryOpenToggle">Show Entry Open Only</label>
</div>
<div style=" left: 30%; position: relative;display: inline;">
  <button class="TornCreate" *ngIf="DataService.LoggedInUser.accessLevel > 1 && DataService.TornStatus == 'ChangeTorn'" type="button" name="btnCreateTorn" id="btnCreateTorn" (click)="addTorn()">Add New Tournament</button>
  <button class="TornCreate" *ngIf="DataService.LoggedInUser.accessLevel > 1 && DataService.TornStatus == 'ChangeTorn' && DataService.LoggedInUser.name == 'Julian Main'" type="button" name="btnYearlyResults" id="btnYearlyResults" (click)="showYearlyResults()">Yearly Results</button>
</div>
<div style="display: inline-grid; left: -360px; position: relative;">
  <div class="TheBlock" name="tornButtons" *ngFor="let torn of DataService.Torns; let i = index">
    <div class="smallLabel" *ngIf="DataService.EntryOpenFilter == false || torn.closingDate > Today">
      <label class="TornLabel">  {{torn.dateOfEvent | date: 'MMM yyyy'}}  </label>
      <button [ngClass]="torn.dateOfEvent < Days2Ago ? 'red TheTornButtons' :  Today > torn.closingDate ? 'yellow TheTornButtons' : 'green TheTornButtons'" type="button" id="Torn2023{{i}}" (click)="changeTheTorn(torn)">{{torn.name}}</button>
      <img *ngIf="torn.UserEntered == true && DataService.LoggedInUser.accessLevel > 0" src="../assets/images/star.png" title="You are in this torn :)" />
    </div>
  </div>
</div>
</div>

<div id="OuterContainer" *ngIf="DataService.TornStatus != 'ChangeTorn'">
  <div style="display: flex;">
    <div style="width: 100%;">
      <div id="NavButtons">
        <button type="button" class="TheButtons Brown" id="backToTorns" (click)="this.DataService.TornStatus = 'ChangeTorn'">Back to Tournaments</button>
        <button type="button" *ngIf="DataService.TornStatus != 'ChangeDraw'" class="TheButtons Brown" id="backToDraws" (click)="DataService.TornStatus = 'ChangeDraw'">Back to Draws</button>
        <button type="button" *ngIf="AllowTornUpdate == true && DataService.LoggedInUser.accessLevel > 1 && DataService.SelectedTorn.draws.length == 0" class="TheButtons Brown" id="btnAutoCreate" (click)="LoadAutoCreate()">Auto Create Draws!</button>
      </div>


      <div id="OptionsStrip" style="width: 260px; height: 30px;">
        <div class="Options" id="RefreshToggle" name="RefreshToggle" *ngIf="DataService.SelectedTorn && DataService.SelectedTorn.dateOfEvent < Today && DataService.SelectedTorn.Days2AfterStart > Today">
          <input type="checkbox" (click)="toggleInputMethod()" /><label>Torn Refresh Timer</label>
        </div>
        <div class="Options" id="AllowRepeatToggle" name="AllowRepeatToggle" *ngIf="AllowTornUpdate == true && DataService.SelectedTorn && SelectedTab == 'Draws'">
          <input type="checkbox" [(ngModel)]="DataService.SelectedTorn.AllowRepeat" [ngChange]="AllowRepeatChanged()" /><label>Allow Repeat</label>
        </div>
      </div>
      <h3 id="TornTitle" *ngIf="DataService.SelectedTorn" (click)="EditTornName()">{{DataService.SelectedTorn.name}} ({{DataService.SelectedTorn.dateOfEvent | date: 'yyyy'}})</h3>

      <div>
        <button type="button" *ngIf="DataService.LoggedInUser.accessLevel == 0 && DataService.SelectedTorn.closingDate > Today" class="EnterTornButton" (click)="Register()" >Sign up to Racketlon NZ to enter</button>
        <button type="button" *ngIf="DataService.LoggedInUser.accessLevel > 0 && DataService.SelectedTorn.closingDate > Today && DataService.LoggedInUserAlreadyEnteredInTorn == false" class="EnterTornButton" (click)="showEnterTorns()" >Register for {{DataService.SelectedTorn.name}}</button>
        <button type="button" *ngIf="DataService.LoggedInUser.accessLevel > 0 && DataService.SelectedTorn.closingDate > Today && DataService.LoggedInUserAlreadyEnteredInTorn == true" class="EnterTornButton" (click)="showEnterTorns()" >Withdraw from {{DataService.SelectedTorn.name}}</button>
        <button type="button" *ngIf="showYearlyResultsPage == true" id="btnPrintYearlyResults" (click)="printYearlyResults()" name="PrintYearlyResults">Print Yearly Results</button>
        <button type="button" *ngIf="showYearlyResultsPage == true" id="btnExportYearlyResults" (click)="exportYearlyResults()" name="ExportYearlyResults">Export Yearly Results</button>
      </div>

      <div class="buttonStrip" >
        <div style="margin-left: 5px;" *ngIf="DataService.SelectedTorn.directorId == DataService.LoggedInUser.id && AllowTornUpdate == true || DataService.LoggedInUser.accessLevel > 2">
          <button type="button" *ngIf="SelectedTab == 'Draws'" class="TornCreate" name="btnprintPage" id="btnprintPage" (click)="printPage(DataService.SelectedDraw)">Print Draw</button>
          <button type="button" class="TornCreate" name="btnSettings" id="btnSettings" (click)="editSettings()">Settings</button>
          <button type="button" class="TornCreate" name="btnSchedules" id="btnSchedules" (click)="Schedules()" *ngIf="DataService.SelectedTorn.draws > 0">Schedules</button>
          <button type="button" class="TornCreate" name="btnDownloadScoreSheet" id="btnDownloadScoreSheet" (click)="downloadScoresheet()" *ngIf="DataService.SelectedTorn.draws > 0">Download Scoresheet</button>
          <button type="button" class="TornCreate" name="btnDownloadInfosheet" id="btnDownloadInfosheet" (click)="downloadInfosheet()" *ngIf="DataService.SelectedTorn.presetInfoSheet != ''">Download Infosheet</button>
          <button type="button" class="TornDelete" name="btnDownloadEntries" id="btnDownloadEntries" (click)="DownloadEntryList()">Download Entry List</button>
          <button type="button" class="TornCreate" name="btnAddDraw" id="btnAddDraw" (click)="addDraw()">Add New Draw</button>
          <button type="button" (click)="EditEntries()" id="RefreshEntries" name="RefreshEntries" *ngIf="MonthAgo < DataService.SelectedTorn.dateOfEvent">Edit {{DataService.SelectedTorn.entries.length}} Entries</button>
          <button type="button" class="TornDelete" name="btnDeleteTorn" id="btnDeleteTorn" (click)="DeleteCurrentTorn()">Delete {{DataService.SelectedTorn.name}}</button>
          <button type="button" *ngIf="DataService.LoggedInUser.accessLevel > 1" class="TornDelete" name="btnAnnounce" id="btnAnnounce" (click)="Announcements()">Announcements</button>
        </div>
      </div>
      <div class="SponsorLogo">
        <a ng-href="{{DataService.SelectedTorn.sponsorURL}}"> <img *ngIf="DataService.SelectedTorn.sponsorImage" src="assets/{{DataService.SelectedTorn.sponsorImage}}" width="170" height="50"/></a>
      </div>
    </div>
  </div>

  <div id="TabControl">
    <div class="tab">
      <button type="button" title="{{draw.theEvent?.type}}" class="DrawButton" [ngClass]="drawButtonColorDecide(draw)" id="DrawsD{{i}}" *ngFor="let draw of DataService.SelectedTorn.draws; let i = index" (click)="showDraw(i)">{{draw.name}}</button>
      <button type="button" class="PlayerButton" (click)="changeTab('Players')">PlayerList ({{DataService.SelectedTorn.entries.length}})</button>
      <button type="button" class="InfoButton" (click)="changeTab('Info')">Info</button>
      <button *ngIf="DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == DataService.LoggedInUser.id" type="button" class="InfoButton" (click)="changeTab('Events')">Events</button>
      <button *ngIf="DataService.SelectedTorn.hasTeams == true" type="button" class="InfoButton" (click)="changeTab('Teams')">Teams</button>
    </div>

    <div *ngIf="DataService.TornStatus == 'Settings'">
      <div>
        <Label>Doubles Day:</Label>
        <input type="radio" id="rdoSaturday" name="DayForDoubs" [(ngModel)]="DataService.SelectedTorn.doubles" value="Saturday" />Saturday
        <input type="radio" id="rdoSunday" name="DayForDoubs" [(ngModel)]="DataService.SelectedTorn.doubles" value="Sunday" />Sunday
      </div>
      <div style="margin-top: 25px">
        <Label for="txtCourts">Courts:</Label><input type="number" id="txtCourts" name="Courts" [(ngModel)]="DataService.SelectedTorn.courts" value="4" style="width:50px" /><br />
      </div>
      <div style="margin-top: 25px;">
        <label for="txtDiscount">Discount:</label><input type="number" id="txtDiscount" [(ngModel)]="DataService.SelectedTorn.discount" />
      </div>
      <input style="margin-top: 25px;" type="button" id="btnUpdateTornSettings" name="TornUpdate" (click)="UpdateTorn(DataService.SelectedTorn);DataService.TornStatus = 'ChangeDraw'" value="Update Torn"/>
    </div>

    <Teams id="Draws" class="tabcontent" *ngIf="SelectedTab == 'Teams'">
    <h3>Teams:</h3>
    <div style="display: inline-block;" *ngIf="DataService.SelectedTorn.Teams.length > 0 && (DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == LoggedInUser.id)">
      <label for="chkEditTeams">Edit</label>
      <input type="checkbox" id="chkEditTeams" [(ngModel)]="DataService.SelectedTorn.EditTeams" style="height: 20px; margin-top: 0px"/>
    </div>
    <div *ngIf="DataService.SelectedTorn.EditTeams == true && DataService.SelectedTorn.Teams.length > 0">
      <EventHeadings style="display: inline-block; width: 592px;"><label style=" text-align: right; width: 196px;">Name</label><label style="text-align: right; width: 196px;">Event</label></EventHeadings><br />
      <div *ngFor="let team of DataService.SelectedTorn.Teams">
        <div style="display: inline-block">
          <input id="teamName{{$index}}" [(ngModel)]="team.Name" ng-style="{backgroundColor: team.Colour}"/>
          <select id="EventList{{$index}}" name="EventList" [(ngModel)]="team._Event">
            <option *ngFor="let event of DataService.SelectedTorn.events" value="{{event.Id}}">{{event.Name}}</option>
          </select>
          <input type="color" id="clrPicker{{index}}" [(ngModel)]="team.Colour"/>
          <button type="button" *ngIf="team.id > 0" id="btnDeleteTeam{{$index}}" name="deleteTeam" (click)="deleteTeam(team, $index)">Delete</button>
          <button type="button" *ngIf="!team.id" id="btnSaveTeam{{$index}}" name="saveTeam" (click)="saveNewTeam(team, $index)">Save</button><br />
        </div>
      </div>
      <button *ngIf="DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == LoggedInUser.id" type="button" id="btnAddTeam" (click)="addTeam()">+</button>
      <button *ngIf="DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == LoggedInUser.id" type="button" id="btnSaveTeams" (click)="saveTeams()">Save</button>
    </div>
    <div *ngIf="DataService.SelectedTorn.EditTeams == false && DataService.SelectedTorn.Teams.length > 0">
      <table>
        <thead>
          <tr>
            <th>Position</th>
            <th>Team Name</th>
            <th>Points</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let team of DataService.SelectedTorn.Teams" ng-style="{backgroundColor: team.Colour}">
            <td>{{$index+1}}</td>
            <td>{{team.Name}}</td>
            <td>{{team.Points}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Teams>

  <div id="Draws" class="tabcontent" *ngIf="SelectedTab == 'Draws'"><app-draws [SelectedDrawChanged]="SelectedDrawChanged"></app-draws></div>

  <div id="Players" class="tabcontent" *ngIf="SelectedTab == 'Players'">
    <div id="PlayerLabels">
      <label class="LabelHeading">Player Lists:</label><br />
      <div *ngIf="DataService.SelectedTorn.events.length > 0">
        <div *ngFor="let event of DataService.SelectedTorn.events; let i = index">
          <div class="Divs" *ngIf="event.Players.length > 0">
            <label class="SmallLabelHeadings">{{event.name}}({{event.type}})</label>
            <div id="DrawPlayerListSingles" [ngClass]="event.type == 'Singles' ? 'TheBlock' : 'TheBigBlock'" name="DrawPlayerListSingles" *ngFor="let player of event.Players; let i = index">
              <button type="button" *ngIf="event.type == 'Singles' && player.gender == 'M'" class="ThePlayerButtons Male" id="SinglesPlayers{{event.Id}}{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
              <button type="button" *ngIf="event.type == 'Singles' && player.gender == 'F'" class="ThePlayerButtons Female" id="SinglesPlayers{{event.Id}}{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
              <button type="button" *ngIf="event.type == 'Singles'" class="ThePointsButtons" id="SinglesPlayersPoints{{event.Id}}{{i}}">{{player.singlesPoints}}</button>
              <button type="button" *ngIf="event.type == 'Doubles' && player.gender == 'M' && player.PartnerGender == 'M'" class="ThePlayerButtons Male" id="SinglesPlayers{{event.Id}}{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)" style="width: 280px">{{player.name}}/{{player.PartnerName}}</button>
              <button type="button" *ngIf="event.type == 'Doubles' && player.gender == 'F' && player.PartnerGender == 'F'" class="ThePlayerButtons Female" id="SinglesPlayers{{event.Id}}{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)" style="width: 280px">{{player.name}}/{{player.PartnerName}}</button>
              <button type="button" *ngIf="event.type == 'Doubles' && player.gender != player.PartnerGender" class="ThePlayerButtons Mixed" id="SinglesPlayers{{event.Id}}{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)" style="width: 280px">{{player.name}}/{{player.PartnerName}}</button>
              <button type="button" *ngIf="event.type == 'Doubles' && player.doublesTotalPoints > 0" class="ThePointsButtons" id="DoublesPlayersPoints{{event.id}}{{i}}">{{player.doublesTotalPoints}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="Divs" *ngIf="!DataService.SelectedTorn.events || DataService.SelectedTorn.events.length == 0">
        <label *ngIf="DataService.SelectedTorn.SinglesPlayers.length > 0" class="SmallLabelHeadings">Singles ({{DataService.SelectedTorn.SinglesPlayers.length}})</label>
        <div id="DrawPlayerListSingles" class="TheBlock" name="DrawPlayerListSingles" *ngFor="let player of DataService.SelectedTorn.SinglesPlayers;  let i = index">
          <button type="button" *ngIf="player.Singles == true && player.gender == 'M'" class="ThePlayerButtons Male" id="SinglesPlayers{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
          <button type="button" *ngIf="player.Singles == true && player.gender == 'F'" class="ThePlayerButtons Female" id="SinglesPlayers{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
          <button type="button" *ngIf="player.Singles == true" class="ThePointsButtons" id="SinglesPlayersPoints{{i}}" (click)="editUser(player.id)">{{player.singlesPoints}}</button>
        </div>
      </div>
      <div class="Divs" *ngIf="!DataService.SelectedTorn.events || DataService.SelectedTorn.events.length == 0">
        <label *ngIf="DataService.SelectedTorn.DoublesPlayers.length > 0" class="SmallLabelHeadings">Doubles ({{DataService.SelectedTorn.DoublesPlayers.length}})</label>
        <div id="DrawPlayerListDoubles" class="TheBlock" name="DrawPlayerListDoubles" *ngFor="let player of DataService.SelectedTorn.DoublesPlayers; let i = index">
          <button type="button" *ngIf="player.Doubles == true && player.gender == 'M'" class="ThePlayerButtons Male" id="DoublesPlayers{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
          <button type="button" *ngIf="player.Doubles == true && player.gender == 'F'" class="ThePlayerButtons Female" id="DoublesPlayers{{i}}" (click)="showPlayersMatches(player.id, DataService.SelectedTorn.id)">{{player.name}}</button>
          <button type="button" *ngIf="player.Doubles == true" class="ThePointsButtons" id="DoublesPlayersPoints{{i}}" (click)="editUser(player.id)">{{player.DoublesPoints}}</button>
        </div>
      </div>
    </div>
  </div>

  <Div id="Info" class="tabcontent" *ngIf="SelectedTab == 'Info'" style="display: flex;">
  <div id="TornDetails" *ngIf="DataService.MainStatus == 'Torns' && DataService.TornStatus == 'ChangeDraw'" (click)="changeDatesOfTorn()">
    <label class="Infolabels">Date of Event:</label><label *ngIf="DataService.SelectedTorn" (click)="changeDatesOfTorn()">  {{DataService.SelectedTorn.dateOfEvent | date: 'dd MMM yyyy'}}</label><br /><br />
    <label class="Infolabels">Entries Close:</label><label *ngIf="DataService.SelectedTorn" (click)="changeDatesOfTorn()">  {{DataService.SelectedTorn.closingDate | date: 'dd MMM yyyy'}}</label><br /><br />
    <div *ngIf="DataService.SelectedTorn.Director.Name != ''"><label class="Infolabels">Tournament Director:</label><label>{{DataService.SelectedTorn.Director.name}}</label><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.Director.Email != ''"><label class="Infolabels">Tournament Email:</label><label>{{DataService.SelectedTorn.Director.email}}</label><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn"><label class="Infolabels">Entries:</label><label>{{DataService.SelectedTorn.entries.length}}</label><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.VenueInfo != ''"><label class="Infolabels">Venues:</label><br /><contenteditable>{{DataService.SelectedTorn.VenueInfo}}</contenteditable><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.events.length > 0">
      <label class="Infolabels">Events:</label>
      <ul>
        <li *ngFor="let theEvent of DataService.SelectedTorn.events" style=" text-align: initial;">{{theEvent.name}}  {{theEvent.type}}  ${{theEvent.cost}}</li>
      </ul>
    </div>
    <div *ngIf="DataService.SelectedTorn.accomodationInfo != ''"><label class="Infolabels">Accomodation:</label><br /><contenteditable>{{DataService.SelectedTorn.accomodationInfo}}</contenteditable><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.scheduleInfo != ''"><label class="Infolabels">Schedules:</label><br /><contenteditable>{{DataService.SelectedTorn.scheduleInfo}}</contenteditable><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.prizeGivingInfo != ''"><label class="Infolabels">Prize Giving:</label><br /><contenteditable>{{DataService.SelectedTorn.prizeGivingInfo}}</contenteditable><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.extraInfo != ''"><label class="Infolabels">Extra:</label><br /><contenteditable>{{DataService.SelectedTorn.extraInfo}}</contenteditable><br /><br /></div>
    <div *ngIf="DataService.SelectedTorn.liveStreamURL"><label class="Infolabels"><a target="_blank" href="{{DataService.SelectedTorn.LiveStreamURL}}">Live Stream Link!:</a></label><br /><br /></div>
  </div>
  <img id="imgPoster" *ngIf="DataService.SelectedTorn.PosterLocation" ng-src="{{DataService.SelectedTorn.PosterLocation}}" style="width: 50%" />
</Div>

<Events id="Events" class="tabcontent" *ngIf="SelectedTab == 'Events'">
<h3>Events:</h3>
<EventHeadings style="display: inline-block; width: 1083px;left: -164px;position: relative;"><label style=" text-align: right;">Teams</label><label>Name</label><label>Type</label><label class="small"> Age ></label><label class="small">< Age</label><label class="small">Cost</label></EventHeadings><br />
<div *ngFor="let event of DataService.SelectedTorn.events; let i = index">
  <div style="display: inline-block">
    <input type="checkbox" id="eventTeams{{i}}" [(ngModel)]="event.Teams" (ngModelChange)="event.updateNeeded = true"/>
    <input id="eventName{{i}}" [(ngModel)]="event.name" (ngModelChange)="event.updateNeeded = true"/>
    <input id="eventType{{i}}" [(ngModel)]="event.type" (ngModelChange)="event.updateNeeded = true"/>
    <input id="eventCost{{i}}" [(ngModel)]="event.minAge" class="number" (ngModelChange)="event.updateNeeded = true"/>
    <input id="eventMin{{i}}" [(ngModel)]="event.maxAge" class="number" (ngModelChange)="event.updateNeeded = true"/>
    <input id="eventMax{{i}}" [(ngModel)]="event.cost" class="number" (ngModelChange)="event.updateNeeded = true"/>
    <button *ngIf="event.updateNeeded == true" type="button" id="btnSaveEvent{{i}}" name="deleteEvent" (click)="saveEvent(event)">Save</button>
    <button type="button" id="btnDeleteEvent{{i}}" name="deleteEvent" (click)="deleteEvent(event, i)">Delete</button>
  </div>
</div>
<button *ngIf="DataService.LoggedInUser.accessLevel == 3 || DataService.SelectedTorn.DirectorId == DataService.LoggedInUser.id" type="button" id="btnAddEvent" (click)="addEvent()">+</button>
</Events>

<div *ngIf="DataService.TornStatus == 'PlayersMatches'" style="margin-top: 1%; display: inline-grid;float: left">

  <button style="display: block;" type="button" id="btnBackFromPlayersMatches" name="btnBack" (click)="SelectedTab = BackTo;DataService.TornStatus = ''">Back to</button>
  <div>
    <h2>{{SelectedPlayer.name}}</h2>
    <button type="button" *ngIf="DataService.LoggedInUser.accessLevel > 2" (click)="editPlayer(SelectedPlayer)" style="background-color: deeppink">Edit</button>
    <button type="button" (click)="showHistory(SelectedPlayer)" style="background-color: deeppink">History</button>
  </div>
  <h1 *ngIf="DataService.SelectedTorn.events.length > 0">Events Entered:</h1>
  <div class="TheBlock" style="width: 500px" id="tornEvents" *ngFor="let TheEvent of SelectedPlayersEntry.EventsEntered; ">
    <label *ngIf="TheEvent.Entered == true" id="lblEvent{{$index}}">{{TheEvent.name}} - {{TheEvent.type}}</label><label style="width: auto" *ngIf="TheEvent.Entered == true && TheEvent.type == 'Doubles'" id="lblEventPartner{{$index}}"> - {{TheEvent.partnerName}}</label>
  </div>
  <div class="TheBlock" name="tornButtons" *ngFor="let match of DataService.Matches;">
    <button type="button" class="TheTornButtons" *ngIf="(match.player1 == SelectedPlayer.id && match.player3 == 0) && TornID == match.torn && match.ttScore1+match.badScore1+match.squashScore1+match.tScore1+match.ttScore2+match.badScore2+match.squashScore2+match.tScore2 > 0" id="PlayerMatches1{{$index}}" style="width: 800px;">{{match.WinnerId == SelectedPlayer.id ? "Won" : "Lost"}} V {{match.player2Name}} - {{match.ttScore1}}-{{match.ttScore2}},{{match.badScore1}}-{{match.badScore2}},{{match.squashScore1}}-{{match.squashScore2}},{{match.tScore1}}-{{match.tScore2}} = {{match.ttScore1+match.badScore1+match.squashScore1+match.tScore1}}-{{match.ttScore2+match.badScore2+match.squashScore2+match.tScore2}}</button>
    <button type="button" class="TheTornButtons" *ngIf="(match.player2 == SelectedPlayer.id && match.player3 == 0) && TornID == match.torn && match.ttScore1+match.badScore1+match.squashScore1+match.tScore1+match.ttScore2+match.badScore2+match.squashScore2+match.tScore2 > 0" id="PlayerMatches2{{$index}}" style="width: 800px;">{{match.WinnerId == SelectedPlayer.id ? "Won" : "Lost"}} V {{match.player1Name}} - {{match.ttScore1}}-{{match.ttScore2}},{{match.badScore1}}-{{match.badScore2}},{{match.squashScore1}}-{{match.squashScore2}},{{match.tScore1}}-{{match.tScore2}} = {{match.ttScore1+match.badScore1+match.squashScore1+match.tScore1}}-{{match.ttScore2+match.badScore2+match.squashScore2+match.tScore2}}</button>
    <button type="button" class="TheTornButtons" *ngIf="(match.player1 == SelectedPlayer.id || match.player3 == SelectedPlayer.id) && match.player3 > 0 && TornID == match.torn && match.ttScore1+match.badScore1+match.squashScore1+match.tScore1+match.ttScore2+match.badScore2+match.squashScore2+match.tScore2 > 0" id="PlayerMatches1{{$index}}" style="width: 900px;">{{match.WinnerId == SelectedPlayer.id || match.WinnerPartnerId == SelectedPlayer.id ? "with "+SelectedPlayer.PartnerName + " Won" : match.LoserId == SelectedPlayer.id || match.LoserId == SelectedPlayer.PartnerId ? "with "+SelectedPlayer.PartnerName + " Lost" : " shit"}} V {{match.player2Name}} - {{match.ttScore1}}-{{match.ttScore2}},{{match.badScore1}}-{{match.badScore2}},{{match.squashScore1}}-{{match.squashScore2}},{{match.tScore1}}-{{match.tScore2}} = {{match.ttScore1+match.badScore1+match.squashScore1+match.tScore1}}-{{match.ttScore2+match.badScore2+match.squashScore2+match.tScore2}}</button>
    <button type="button" class="TheTornButtons" *ngIf="(match.player2 == SelectedPlayer.id || match.player4 == SelectedPlayer.id) && match.player3 > 0 && TornID == match.torn && match.ttScore1+match.badScore1+match.squashScore1+match.tScore1+match.ttScore2+match.badScore2+match.squashScore2+match.tScore2 > 0" id="PlayerMatches2{{$index}}" style="width: 900px;">{{match.WinnerId == SelectedPlayer.id || match.WinnerPartnerId == SelectedPlayer.id ? "with "+SelectedPlayer.PartnerName + " Won" : match.LoserId == SelectedPlayer.id || match.LoserId == SelectedPlayer.PartnerId ? "with "+SelectedPlayer.PartnerName + " Lost" : " shit"}} V {{match.player1Name}} - {{match.ttScore1}}-{{match.ttScore2}},{{match.badScore1}}-{{match.badScore2}},{{match.squashScore1}}-{{match.squashScore2}},{{match.tScore1}}-{{match.tScore2}} = {{match.ttScore1+match.badScore1+match.squashScore1+match.tScore1}}-{{match.ttScore2+match.badScore2+match.squashScore2+match.tScore2}}</button>
  </div>
</div>

<EditEntries *ngIf="DataService.MainStatus == 'Torns' && DataService.TornStatus == 'EditEntries'">
<div>
  <h2>{{DataService.SelectedTorn.entries.length}} Entries</h2>
  <select id="CreateEntryFromPlayer" name="CreateEntryFromPlayer" style=" margin-bottom: 10px;" [(ngModel)]="SelectedPlayer">
    <option *ngFor="let Player of DataService.Players; let i = index" name="Player{{i}}" [ngValue]="Player"  id="Player{{i}}">{{Player.name}}</option>
  </select>
  <button *ngIf="AllowTornUpdate == true" type="button" id="addEntryAdd" name="addEntry" (click)="addANewEntry()" style="margin: 3px;">Add new Entry</button>
  <button *ngIf="AllowTornUpdate == true" type="button" id="addEntryCreate" name="addEntry" (click)="addANewPerson()" style="margin: 3px;">Create New Person</button>
  <table class="table-layout">
    <thead>
      <tr>
        <th>Delete</th>
        <th>Name</th>
        <th>Province</th>
        <th>Paid</th>
        <th *ngFor="let event of DataService.SelectedTorn.events">{{event.name}}-{{event.type}}</th>
        <th *ngIf="DataService.SelectedTorn.isTeams == true">Team</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td>Totals:</td>
        <td *ngFor="let TheEvent of DataService.SelectedTorn.events">
          {{TheEvent.Total}}
          <img *ngIf="TheEvent.Good == true" src="../assets/images/small-nice-Green-Tick.png" width="20" title="good number for a draw" />
          <img *ngIf="TheEvent.Good == false" src="../assets/images/small-nice-red-cross.png" width="20" title="bad number for a draw"/>
        </td>
      </tr>
      <tr *ngFor="let entry of DataService.SelectedTorn.entries; let EntryIndex = index" ng-init="EntryIndex = $index">
        <td><button type="button" (click)="deleteSelectedEntry(entry)">X</button></td>
        <td ng-class="entry.Gender == 'M' ? 'Male' : 'Female'">{{entry.name}}</td>
        <td>{{entry.province}}</td>
        <td (click)="ToggleFeesPaid(entry)" style="cursor: pointer">{{entry.feesPaid}}</td>
        <td *ngFor="let AnEvent of entry.EventsEntered; let eventIndex = index">
          <input type="checkbox" id="chkEventC{{eventIndex}}D{{EntryIndex}}" *ngIf="(entry.YearsOld == 0 || entry.YearsOld > 100) || (entry.YearsOld > AnEvent.minAge && entry.YearsOld < AnEvent.maxAge)" [(ngModel)]="AnEvent.Entered" (click)="addEventToPlayersEntry(entry, eventIndex, $event)" />
          <select *ngIf="AnEvent.Entered == true && AnEvent.type == 'Doubles' && AnEvent.PartnerId == 0" id="SelectPlayerToAssign{{eventIndex}}{{entry.id}}" name="SelectPlayerToAssign" (ngModelChange)="partnerAssigned(entry, eventIndex, $event)" [(ngModel)]="AnEvent.PartnerId" >
            <option  name="ThePartner" value="{{Entry2.playerId}}" id="ThePartner" *ngFor="let Entry2 of DataService.SelectedTorn.entries">
              <div *ngIf="Entry2.playerId != entry.playerId && Entry2.EventsEntered[eventIndex].Entered == true && Entry2.EventsEntered[eventIndex].PartnerId == 0" [ngValue]="Entry2.playerId">{{Entry2.name}}</div>
            </option>
          </select>
          <label *ngIf="AnEvent.PartnerId > 0" style="font-size: 14px; text-align: center; width: auto; border: 1px solid blue; padding: 2px; " (click)="clearPartner(entry, eventIndex)">{{AnEvent.PartnerName}}</label>
        </td>
        <td *ngIf="DataService.SelectedTorn.isTeams == true">
          <select id="SelectTeamToAssign{{sectionIndex}}{{i}}{{entry.id}}" name="SelectTeamToAssign" [Change]="teamAssigned(entry)" [(ngModel)]="entry.Team" ng-options="team.id as team.Name for team in DataService.SelectedTorn.Teams">
          </select>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</EditEntries>
</div>
</div> -->